import _get from 'lodash/get';
export default {
  getOwners: state => _get(state, 'owners', {})
};